import { render, staticRenderFns } from "./ReaderForm.vue?vue&type=template&id=115026b7&"
import script from "./ReaderForm.vue?vue&type=script&lang=js&"
export * from "./ReaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115026b7')) {
      api.createRecord('115026b7', component.options)
    } else {
      api.reload('115026b7', component.options)
    }
    module.hot.accept("./ReaderForm.vue?vue&type=template&id=115026b7&", function () {
      api.rerender('115026b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/ReaderForm.vue"
export default component.exports